import { render, staticRenderFns } from "./Materials.vue?vue&type=template&id=5b83bd6c&scoped=true"
import script from "./Materials.vue?vue&type=script&lang=js"
export * from "./Materials.vue?vue&type=script&lang=js"
import style0 from "./Materials.vue?vue&type=style&index=0&id=5b83bd6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b83bd6c",
  null
  
)

export default component.exports